import {z} from 'zod';

export const configSchema = z.object({
  VITE_API_URL: z.string().min(1, 'VITE_API_URL is required'),
  VITE_LOGOUT_URL: z.string().min(1, 'VITE_LOGOUT_URL is required'),
  VITE_MCP_SERVER_NAME: z.string().min(1).default('backoffice-local'),
  VITE_SENTRY_DSN: z.string().optional(),
  VITE_ENABLE_MOCK_SCHUFA: z.string().optional(),
});
